import { styled, Typography, Box } from "@mui/material";

export const StyledText = styled(Typography)({
  fontSize: "14px",
  fontWeight: "400",
  color: "#fff",
  letterSpacing: "0.1px",
  lineHeight: "20px",
  marginRight: "10px",
});

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1),
  marginRight: theme.spacing(1.25),
  /** Whole row: "Viewing:" + field — wide enough for full "No Customer Selected". */
  minWidth: 320,
  width: "clamp(320px, 38vw, 440px)",
  flexShrink: 0,
  "& > .MuiFormControl-root": {
    flex: "1 1 auto",
    minWidth: 0,
    maxWidth: "100%",
  },
}));
